<template>
    <div class="fixed shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] top-[50%] left-[50%] bg-[#0E1420] p-4 rounded-[10px] mt-[-20px] w-[250px]">
        <div class="text-center mb-3 text-[#FFF]">Ви дійсно хочете видалити тренування {{ element.name }}?</div>
        <div class="flex justify-between">
            <button @click="deleteElement" class="bg-[#F61067] hover:bg-opacity-90 text-white px-4 py-1 rounded-[10px]">Так</button>
            <button @click="$emit('close')" class="px-4 py-1 rounded-[10px] bg-[#C6F100]">Ні</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'delete-element-form',

        props: {
            element: {
                type: Object,
                required: true
            }
        },

        setup(props, { emit }) {
            const deleteElement = () => {
                emit('acceptDeleteElement', props.element)
            }

            return {
                deleteElement
            }
        }
    }
</script>
